const styles = {
  global: {
    body: {
      bg: '#000',
      color: 'white',
      overflowX: 'hidden',
    },
  },
};

export default styles;